import React, { useEffect } from "react";

export function Translator() {
  useEffect(() => {
    const addScript = document.createElement("script");
    addScript.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(addScript);

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "no",
          includedLanguages: "no,en,fr,de,es,hi",
        },
        "google_translate_element"
      );
      // Force auto-translate to English
      // setTimeout(() => {
      //   const select = document.querySelector(".goog-te-combo");
      //   if (select) {
      //     select.value = "no"; // 👈 set target language
      //     select.dispatchEvent(new Event("change"));
      //   }
      // }, 1000);
    };
  }, []);

  return <div id="google_translate_element"></div>;
}